import { create } from 'zustand';

interface PatientContext {
  patientId: number;
  mrn: string;
  fullName: string;
  dateOfBirth: string;
  gender: string;
  allergies: string[];
  codeStatus: string | null;
  isVip: boolean;
  isActive: boolean;
}

interface PatientState {
  currentPatient: PatientContext | null;
  recentPatients: PatientContext[];
  setCurrentPatient: (patient: PatientContext) => void;
  clearCurrentPatient: () => void;
  addToRecentPatients: (patient: PatientContext) => void;
}

export const usePatientStore = create<PatientState>()((set, get) => ({
  currentPatient: null,
  recentPatients: [],
  setCurrentPatient: (patient) => {
    set({ currentPatient: patient });
    // Also add to recent patients (max 10)
    const recent = get().recentPatients.filter(p => p.patientId !== patient.patientId);
    set({ recentPatients: [patient, ...recent].slice(0, 10) });
  },
  clearCurrentPatient: () => set({ currentPatient: null }),
  addToRecentPatients: (patient) => {
    const recent = get().recentPatients.filter(p => p.patientId !== patient.patientId);
    set({ recentPatients: [patient, ...recent].slice(0, 10) });
  },
}));
